module.exports = __webpack_public_path__ + "static/media/icon-sessions.f09c059f.svg";